import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { InfoTooltip } from "components/InfoTooltip";
import { ITooltipPlacement } from "components/InfoTooltip/InfoTooltip";

export const ModalTitle = ({
  title,
  stripeWidth = "120px",
  marginBottom = "20px",
  includeTooltip,
  tooltipText,
  tooltipPosition,
}: {
  title: string;
  stripeWidth?: string;
  marginBottom?: string;
  includeTooltip?: boolean;
  tooltipText?: string;
  tooltipPosition?: ITooltipPlacement;
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        mb: marginBottom,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: "10px",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            mr: 1,
          }}
        >
          {title}
        </Typography>
        {includeTooltip && (
          <InfoTooltip title={tooltipText} placement={tooltipPosition} />
        )}
      </Box>
      <Box
        sx={{
          width: stripeWidth,
          height: "1px",
          backgroundColor: theme.palette.secondary.main,
        }}
      />
    </Box>
  );
};
